import { CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS } from '@/app/utils/Collections';
import { FT_LIST, FT_SINGLE, FT_CHECKBOX } from '../FilterTypes';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  account: {
    name: 'Account',
    groupOrderIndex: 1,
  },
};

export default {
  category: CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS,
  filters: [
    {
      id: 'platform',
      isSingle: true,
      label: 'Platform',
      type: FT_LIST,
      group: groups.general,
      multiValues: false,
      getListItems: () => [
        {
          id: 'instagram',
          name: 'Instagram',
        },
        {
          id: 'facebook',
          name: 'Facebook',
        },
        {
          id: 'x',
          name: 'Twitter/X',
        },
        {
          id: 'youtube',
          name: 'YouTube',
        },
        {
          id: 'linkedin',
          name: 'LinkedIn',
        },
      ],
    },
    {
      id: 'core_session_id',
      label: 'Session ID',
      type: FT_SINGLE,
      group: groups.general,
      hint: 'Session identifier from the Sessions tab',
    },
    {
      id: 'is_core',
      label: 'Is Core',
      fieldConf: {
        label: 'Show core items',
      },
      group: groups.general,
      type: FT_CHECKBOX,
      defaultValue: () => true,
    },
    {
      id: 'account_url',
      label: 'Account URL',
      type: FT_SINGLE,
      group: groups.account,
    },
    {
      id: 'username',
      label: 'User name',
      type: FT_SINGLE,
      group: groups.account,
    },
  ],
  searchBarProp: 'complex_name',
};
